import { Button, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Pagination from "../Pagination";
// import { getSurveyorSurveys } from "../../../api/SurveyorApiRequest";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { useNavigate } from "react-router-dom";
import { getSurveyorBidList } from "../../../api/CommonRequest";

function BidList({ id }) {
  const navigate=useNavigate()
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("");
  const [surveyorBids, setSurveyorBids] = useState([]);

  const surveyStats = [
    { label: "All", value: "", name: "all" },
    { label: "Live", value: "live", name: "live" },
    { label: "Pending", value: "pending", name: "pending" },
    { label: "Approved", value: "approved", name: "approved" },
    { label: "Hold", value: "hold", name: "hold" },
  ];

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getSurveyorBidList(id, {
          page: currentPage,
          limit: limit,
          status: activeTab,
        });

        if (data?.success) {
          
          setSurveyorBids(data?.surveyorBids);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
        }
      } catch (error) {
        console.error(error);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      } finally {
        setLoader(false);
      }
    };
    bidsCall();
  }, [limit, currentPage, activeTab, id]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value);
    setLimit(selectedValue);
    setCurrentPage(1);
  };

  const getStatusColor = (status) => {
    const statusColors = {
      live: "green",
      pending: "gold",
      approved: "blue",
      hold: "red",
    };
    return statusColors[status] || "default";
  };

  const columns = [
    // {
    //   title: "",
    //   dataIndex: "checkbox",
    //   key: "checkbox",
    //   render: () => <input type="checkbox" />,
    //   width: 50,
    // },
    
    {
      title: "Product Name",
      key: "productName",
      render: (_, record) => (
        <div>
          <div className="font-medium">{record.productName}</div>
        </div>
      ),
    },
    {
      title: "Category Details",
      key: "categoryDetails",
      render: (_, record) => (
        <div>
          <div className="font-medium">{record.category.name}</div>
          <div className="text-gray-500">{record.subCategory.name}</div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={getStatusColor(status)}>{status.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Expected Price",
      dataIndex: "expectedPrice",
      key: "expectedPrice",
      render: (price) => `₹${price.toLocaleString()}`,
    },
   
    {
      title: "Created Date",
      dataIndex: "assignedDate",
      key: "assignedDate",
      render: (date) => moment(date).format("DD/MM/YYYY"),
    },
    {
      title: "View",
      dataIndex: "_, record",
      key: "record",
      render: (text,record) =><Button  className="bg-blue-600 px-6 py-3 text-white" onClick={()=>{navigate('/bid-detailed-view',{state:record._id})}}>View</Button>,
      align:"center"
    
    },
    
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-2">
        {surveyStats.map((stat) => (
          <Button
            key={stat.name}
            type={activeTab === stat.value ? "primary" : "default"}
            onClick={() => {
              setActiveTab(stat.value);
              setCurrentPage(1);
            }}
          >
            {stat.label}
          </Button>
        ))}
      </div>

      <div className="space-y-4">
        <Table
          loading={loader}
          columns={columns}
          dataSource={surveyorBids}
          pagination={false}
          className="custom-table-header lg:w-full w-[250px] overflow-auto custom-pagination"
        />

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          limit={limit}
          totalItem={totalItems}
          onPageChange={handlePageChange}
          handleLimit={handleLimit}
        />
      </div>
    </div>
  );
}

export default BidList;
